import RedEye from '../3D/RedEye';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header, { Header_Link } from '../layout/Header';
import DefaultNoScroll from './DefaultNoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import gsap, { Expo, Power2, Power3 } from 'gsap';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import CircleSlider from '../3D/CircleSlider';
import WheelControls from '../_app/cuchillo/scroll/WheelControls';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { DataHolder } from '../DataHolder';
import { Basics } from '../_app/cuchillo/core/Basics';

export default class Home extends DefaultNoScroll {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  scroller;

  constructor() {
    super();
    Basics.oldPage = "home";
    document.body.classList.add("--remove-footer");
    DataHolder.update();
  }

  beforeShow() {
    Header.title.hide();
    super.beforeShow();
  }

  afterShow() {
    super.afterShow();
    CircleSlider.getInstance().show();
  }

  show__effect(__call) {
    Header.mode = "WHITE";
    Wrap.directShow();
    //

    if (this.isFirstTime) {
      setTimeout(() => { 
        CircleSlider.getInstance().show();
      }, 500);     
      setTimeout(() => { 
        Header.show(2,true);
      }, 1000);     
    } else {
      CircleSlider.getInstance().show();
      CircleSlider.getInstance().enabled = true;
      this.afterShow();
    }
  }

  hide__effect() {
    CircleSlider.getInstance().hide();
    Wrap.hide(() => { this.afterHide() }, { duration: .5 });
  }

  beforeHide() {
    document.body.classList.remove("--remove-footer");
    super.beforeHide();
  }
  afterHide() {
    Header.mode = "INVERT";
    super.afterHide();
  }

  loop() {
    /*if(this.scroller.total_items > 2) {
      this.scroller.loop();
    }*/


  }

  resize() {
    super.resize();
  }
}

ControllerPage._addPage("home", Home)
